import { render, staticRenderFns } from "./nota.vue?vue&type=template&id=49bc0ae7&scoped=true&"
import script from "./nota.vue?vue&type=script&lang=js&"
export * from "./nota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc0ae7",
  null
  
)

export default component.exports